import dayjs from 'dayjs';
import React from 'react';
import { PopoverContent, PopoverTitle } from 'react-bootstrap';
import { LedgerType } from 'src/pages/pto/types';
import './CreateDatePopover.css'

interface IProps {
    ledgerItem: LedgerType;
    creationDate: dayjs.Dayjs;
    modifiedDate: dayjs.Dayjs;
}

const CreateDatePopover: React.FC<IProps> = (props) => {
    const { ledgerItem, creationDate, modifiedDate} = props;
    
    if(ledgerItem.status !== "Pending"){
        return(
            <>
                <PopoverTitle className='comment-title' as="h5">
                    Request Details
                </PopoverTitle>               
                <PopoverContent>
                    Added by {ledgerItem.createdByDisplayName}, on {creationDate.local().format('MM/DD/YYYY hh:mm a')}
                    <hr/>
                    {
                        ledgerItem.statusSetByDisplayName !== null ?
                        <p>Status modified by {ledgerItem.statusSetByDisplayName} on {modifiedDate.local().format('MM/DD/YYYY hh:mm a')}</p>
                        : ledgerItem.status === null ?
                        <p>Entered by system on {modifiedDate.local().format('MM/DD/YYYY hh:mm a')}</p>
                        : <p>{ledgerItem.status} by {ledgerItem.statusSetByDisplayName} on {modifiedDate.local().format('MM/DD/YYYY hh:mm a')}</p> 
                    } 
                </PopoverContent>   
            </>       
        )
    } else {
        return(
            <>
                <PopoverTitle as="h5" className='comment-title'>
                    Request Details
                </PopoverTitle>
                <PopoverContent>
                    Added by {ledgerItem.createdByDisplayName}, on {creationDate.local().format('MM/DD/YYYY hh:mm a')}
                </PopoverContent>
            </>
        )
    }
}
export default CreateDatePopover;